// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class SetFloat {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetFloat {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetFloat(bb: flatbuffers.ByteBuffer, obj?: SetFloat): SetFloat {
    return (obj || new SetFloat()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetFloat(bb: flatbuffers.ByteBuffer, obj?: SetFloat): SetFloat {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetFloat()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  static startSetFloat(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldFloat32(0, value, null)
  }

  static endSetFloat(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetFloat(builder: flatbuffers.Builder, value: number | null): flatbuffers.Offset {
    SetFloat.startSetFloat(builder)
    if (value !== null) SetFloat.addValue(builder, value)
    return SetFloat.endSetFloat(builder)
  }
}
